import * as Yup from 'yup'
import { Form } from 'react-bootstrap'
import { CustomFormControl } from '../../../../StyledComponents';
import { checkRequiredText } from '../ValidationRules';

export const Schema = (settings) => Yup.object().shape({
    periodOfCancellation: checkRequiredText(settings),
});

export const PeriodOfCancelationSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>

            <Form.Group className="mb-3" controlId="formPeriodOfCancellation">
                <Form.Label>Kündigungsfrist/Frühestmöglicher Eintritt*</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Kündigungsfrist eingeben"
                    type="text"
                    name="periodOfCancellation"
                    value={values.periodOfCancellation}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.periodOfCancellation && !errors.periodOfCancellation}
                    isInvalid={touched.periodOfCancellation && errors.periodOfCancellation}
                    maxLength={settings.textInputLimit}
            />
                <Form.Control.Feedback type="invalid">
                    {errors.periodOfCancellation}
                </Form.Control.Feedback>
            </Form.Group>
        
        </>
    );
};